<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4>Archivo</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Nombre</th>
          <th scope="col">Ruta</th>
          <th scope="col">Tipo</th>
          <th scope="col">FechaCrea</th>
          <th scope="col">FechaMod</th>
          <th scope="col">Tamano</th>
          <th scope="col">PedidoFechaReg</th>
          <th scope="col">PedidoFechaAct</th>
          <th scope="col">PedidoObservacion</th>
          <th scope="col">PedidoEstado</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="archivo in datosPaginados" :key="archivo.idArchivo">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(archivo.idArchivo)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(archivo.idArchivo)" title="Editar">edit_square</i></td>
          <td>{{archivo.nombre}}</td>
          <td>{{archivo.ruta}}</td>
          <td>{{archivo.tipo}}</td>
          <td>{{getFormattedDate(archivo.fechaCrea, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(archivo.fechaMod, 'DD/MM/YYYY')}}</td>
          <td>{{archivo.tamano}}</td>
          <td>{{getFormattedDate(archivo.pedidoFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(archivo.pedidoFechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{archivo.pedidoObservacion}}</td>
          <td>{{archivo.pedidoEstado}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteArchivo(archivo.idArchivo)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idArchivo" class="form-label">IdArchivo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idArchivo" name="idArchivo" v-model="datoArchivo.idArchivo" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Pedido -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPedido" class="form-label"> Pedido</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPedido" name="idPedido" v-model="datoArchivo.idPedido">
                      <option v-for="pedido in pedidos" :value="pedido.idPedido" :key="pedido.idPedido">
                        {{ pedido.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Pedido -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombre" name="nombre" v-model="datoArchivo.nombre" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="ruta" class="form-label">Ruta</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="ruta" name="ruta" v-model="datoArchivo.ruta" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipo" name="tipo" v-model="datoArchivo.tipo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaCrea" class="form-label">FechaCrea</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaCrea" name="fechaCrea" v-model="datoArchivo.fechaCrea" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaMod" class="form-label">FechaMod</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaMod" name="fechaMod" v-model="datoArchivo.fechaMod" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tamano" class="form-label">Tamaño</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tamano" name="tamano" v-model="datoArchivo.tamano" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarArchivo" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditArchivo" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      archivos : [],
      datoArchivo : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      pedidos: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchPedidos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.archivos.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwarchivos/nombre/'+this.nombreBusqueda).then(response=>{
          this.archivos=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.archivos.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwarchivos').then(response=>{
      this.archivos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.archivos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idPedido'
        ,'nombre'
        ,'ruta'
        ,'tipo'
        ,'fechaCrea'
        ,'fechaMod'
        ,'tamano'
      ];
      const requiredFieldsText = [
        'idPedido'
        ,'nombre'
        ,'ruta'
        ,'tipo'
        ,'fechaCrea'
        ,'fechaMod'
        ,'tamano'
      ];
      return validarForm(this.datoArchivo, requiredFields, requiredFieldsText);
    },
    async guardarArchivo(){
      if(this.validarForm() === 1){
        try {
          await api.post('/archivos', this.datoArchivo)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Archivo creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditArchivo(){
      if(this.validarForm() === 1){
        try {
          await api.post('/archivos', this.datoArchivo)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Archivo creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoArchivo={}
      this.titulo   = 'Crear Archivo'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idArchivo){
      this.modalWindow = true
      if(idArchivo != null){    
           api.get('/vwarchivos/'+idArchivo).then(resp=>{
          this.datoArchivo = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Archivo'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idArchivo){
      if(idArchivo != null){
        this.$router.push('/archivomd/'+idArchivo)
      }
    },
    async deleteArchivo (idArchivo) {
      try{
        await api.delete('/archivos/'+idArchivo)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchPedidos() {
      fetch('http://localhost:8080/api/v1/pedidos')
        .then(response => response.json())
        .then(data => {
          this.pedidos = data;
        })
        .catch(error => {
          console.error('Error fetching pedidos:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
